'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/secondsUntil.js
// module id = 355
// module chunks = 0